const {
  cloneDeep
} = require('lodash');
const {
  uuid
} = require('../lib/common');

/**
  * @function evalute - evaluate updateAuditTrailAndCreatedDateBehavior
  *
  * The behavior takes audit trail formatted entries are sets the _created date
  * to the current date/time
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const auditTrail = await sourceEvaluator(source.entries);
  if (auditTrail === undefined) {
    return undefined;
  }
  const updatedAuditTrail = Object.keys(auditTrail).reduce((acc, key) => {
    const updatedKey = uuid();
    const auditTrailEntry = cloneDeep(auditTrail[key]);

    /* eslint-disable no-underscore-dangle */
    if (auditTrailEntry._created) {
      auditTrailEntry._created = new Date().toISOString();
    }
    /* eslint-enable no-underscore-dangle */

    acc[updatedKey] = auditTrailEntry;
    return acc;
  }, {});
  return updatedAuditTrail;
};
module.exports = {
  evaluate
};